import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import { callHistoryRowKey, callRecordKeyDates, rowIsFocusable } from 'flow/components/call-history-v2/call-history-rows';
import DateGroupedList from 'flow/components/call-history-v2/DateGroupedList';
import MissedQueueCallItem from './MissedQueueCallItem';
import { jsx as _jsx } from "react/jsx-runtime";
/** The missed queue calls by date, with the rows of the PBX call history. */
var MissedQueueCallsList = function MissedQueueCallsList(_ref) {
  var callRecordKeysByDate = _ref.callRecordKeysByDate;
  var dates = useMemo(function () {
    return callRecordKeyDates(callRecordKeysByDate);
  }, [callRecordKeysByDate]);
  var renderRow = function renderRow(row, rowProps) {
    return /*#__PURE__*/_jsx(MissedQueueCallItem, _objectSpread({
      callRecordKey: row.callRecordKey
    }, rowProps));
  };
  return /*#__PURE__*/_jsx(DateGroupedList, {
    dates: dates,
    rowKey: callHistoryRowKey,
    rowIsFocusable: rowIsFocusable,
    renderRow: renderRow
    // The widget's card, so the date titles stand on its colour.
    ,
    bgClassName: "dark:bg-gray-100"
  });
};
export default /*#__PURE__*/React.memo(MissedQueueCallsList);